import { useTranslation } from '../../locale/context';

// import quest from "../assets/keys/key_q.png";
import info from '../assets/keys/key_i.png';
import auto from '../assets/keys/key_a.png';
import setting from '../assets/keys/key_s.png';
import double from '../assets/keys/key_d.png';
import fast from '../assets/keys/key_f.png';
import space from '../assets/keys/key_space.png';
import bet from '../assets/keys/key_bet.png';
import esc from '../assets/keys/key_esc.png';
import bonus from '../assets/keys/key_b.png';
import mute from '../assets/keys/key_m.png';
// import { GameConfigs } from "../../lib/globals/GameConfigs";

export default function Shortcuts() {
	const { t } = useTranslation();

	const KEYS = [
		{
			key: 'A',
			desc: t('gameRules.keyboard_shortcuts.a'),
			visible: true,
			icon: auto
		},
		{
			key: 'Space',
			desc: t('gameRules.keyboard_shortcuts.space'),
			visible: true,
			icon: space
		},
		{
			key: 'B',
			desc: t('gameRules.keyboard_shortcuts.b'),
			visible: true,
			icon: bonus
		},
		// {
		//   key: "Q",
		//   desc: "Open/Close Quests",
		//   visible: GameConfigs.hasQuest,
		//   icon: quest,
		// },
		{
			key: 'D',
			desc: t('gameRules.keyboard_shortcuts.d'),
			visible: true,
			icon: double
		},
		{
			key: 'S',
			desc: t('gameRules.keyboard_shortcuts.s'),
			visible: true,
			icon: setting
		},
		{
			key: 'I',
			desc: t('gameRules.keyboard_shortcuts.i'),
			visible: true,
			icon: info
		},
		{
			key: 'Esc',
			desc: t('gameRules.keyboard_shortcuts.esc'),
			visible: true,
			icon: esc
		},
		{
			key: 'F',
			desc: t('gameRules.keyboard_shortcuts.f'),
			visible: true,
			icon: fast
		},
		{
			key: 'arrows',
			desc: t('gameRules.keyboard_shortcuts.arrows'),
			visible: true,
			icon: bet
		},
		{
			key: 'M',
			desc: t('gameRules.keyboard_shortcuts.m'),
			visible: true,
			icon: mute
		}
	];

	return (
		<div className='wrapper'>
			<div className='content'>
				<div className='title'>{t('settings.keyboard_shortcuts')}</div>
				<div className='key_wrapper'>
					{KEYS.map(
						(item, id) =>
							item.visible && (
								<div key={id} className='key_content'>
									<div className='key_icon'>
										<img src={item.icon} alt={item.key} />
									</div>
									<div className='key_desc'>{item.desc}</div>
								</div>
							)
					)}
				</div>
				<div className='description-sm'>
					{t('gameRules.keyboard_shortcuts.before_use_keys')}
				</div>
			</div>
		</div>
	);
}
